import type { TransferField } from "../../PreviewImportModal.types";

export const getDestinationValueAriaLabel = (row: TransferField) =>
  `Destination value for ${row.ChildFieldDescription ?? "field"}`;
